import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { enumWorkflowState } from '../../../dataObjects/enums';

// export interface IFetchHyperLinksStatusState {
//   value: enumWorkflowState | null
// }

const initialState: enumWorkflowState | null = null;

export const fetchHyperLinksStatusSlice = createSlice({
  name: 'fetchHyperLinksStatus',
  initialState,
  reducers: {
    setFetchHyperLinksStatus: (state: enumWorkflowState | null, action: PayloadAction<enumWorkflowState>) => {
      state = action.payload;
    },
    clearFetchHyperLinksStatus: (state: enumWorkflowState | null) => {
      state = null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { setFetchHyperLinksStatus, clearFetchHyperLinksStatus } = fetchHyperLinksStatusSlice.actions;

// export the core reducer for the slice
export const fetchHyperLinksStatusReducer = fetchHyperLinksStatusSlice.reducer;

export default fetchHyperLinksStatusSlice.reducer;